import React from 'react';
import PropTypes from 'prop-types';

import ReactMarkdown from 'react-markdown';

import { get } from 'lodash-es';

const I18nMarkdown = ({ strings, string, className, defaultValue }) => {
  const source = get(strings, string, string) || defaultValue;
  if (typeof source === 'string') {
    return <ReactMarkdown className={className}>{source}</ReactMarkdown>;
  }
  return defaultValue;
};

I18nMarkdown.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  string: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
};
I18nMarkdown.defaultProps = {
  strings: {},
  string: '',
  defaultValue: '',
  className: 'i18n-markdown',
};

export default I18nMarkdown;
